<template>
    <el-col :xs="{span:24}" :md="width"  v-show="show">
        <el-form-item
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
            <div v-if="isPosition">
                <span>{{ showValue }}</span>
                <div><el-button size="default" @click="position"><el-icon><Place /></el-icon>获取定位</el-button></div>
            </div>
            <template v-else>
                <el-cascader class="qweelement"
                    :disabled="disabled"
                    :props="configData"
                    :model-value="(data[name] || {'Cascader':[]}).Cascader"
                    @update:model-value="updateCascader"
                    :options="options" filterable>
                </el-cascader>
                <el-input v-if="!isOnlyCascader"  :disabled="disabled"
                        style="margin-top:1rem;"
                        :model-value="(data[name] || {'Detail':''}).Detail"
                        @update:model-value="updateDetail"
                        type="textarea"
                        :rows="4"
                        placeholder="详细地址">
                </el-input>
            </template>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import basePositionField from "./BasePositionField"
    import { Place } from '@element-plus/icons-vue'

    export default{
        name:"PositionField",
        mixins:[basePositionField],
        components:{
            Place
        },
        data:{

        }
    }
</script>